var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoStripe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7,
    fill: "#635BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 12.6c0-.6.5-.8 1.2-.8 1 0 2.4.3 3.5.9V9.3a9.2 9.2 0 0 0-3.5-.6c-2.9 0-4.8 1.5-4.8 4 0 3.9 5.3 3.3 5.3 5 0 .6-.5.8-1.3.8-1.1 0-2.6-.5-3.7-1.1v3.4c1.3.5 2.5.8 3.7.8 3 0 5-1.5 5-4 0-4.2-5.4-3.5-5.4-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStripe);
export default __webpack_public_path__ + "static/media/logo-stripe.5729a1cff76d55eaae0aff3d8835347d.svg";
export { ForwardRef as ReactComponent };